<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="12">
        <v-row class="px-3">
          <span class="color-grey font-weight-bold header">Topics</span>
          <v-spacer></v-spacer>
          <router-link to="/dashboard/help_center">
            <span class="color-blue font-weight-bold sub-header">Back to Help Center</span>
          </router-link>
        </v-row>
        <v-row class="mt-3">
          <v-col v-for="i in limit" v-show="loading" cols="12" md="4" class="pt-0">
            <v-skeleton-loader :loading="loading" transition="scale-transition" type="article"></v-skeleton-loader>
          </v-col>
          <TopicCard v-if="topics.length > 0 && !loading" v-for="topic in topics" size="4" :topic_id="topic.sys.id" :loading="loading" :icon="topic.fields.icon" :topic_title="topic.fields.name" :articles="topic.fields.articles"></TopicCard>
          <div v-if="topics.length === 0 && !loading">
            <span class="color-grey text px-4">No Topics.</span>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TopicCard from './TopicCard.vue'
export default {
  components: { TopicCard },
  data() {
    return{
      loading: true,
      limit: 12
    }
  },
  created() {
    this.$store.dispatch('getTopics', null).then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapGetters([
      'topics',
    ])
  }
}
</script>
